"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onCreate: function() {
          this.state = {
              status: [
                  "active",
                  "inactive",
                  "suspended"
                ]
            };
        },
        onSelect: function(status) {
          this.emit("select", status);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SelectStatus.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("6ef835"),
    marko_node0 = marko_createElement("span", {
        "class": "sr-only"
      }, "3", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "font-medium-2 cursor-pointer nav-item px-2 py-50"
      },
    marko_attrs1 = {
        "class": "text-center p-1"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "btn-group dropdown",
        input.class
      ]))
    }, "0", component, null, 1);

  out.be("button", {
      type: "button",
      "class": marko_classValue("btn theme-bg btn-lg round shadow dropdown-toggle" + (input.disabled ? " disabled" : "")),
      "data-toggle": !input.disabled ? "dropdown" : ""
    }, "1", component);

  Locale_tag({
      text: input.label || "Select"
    }, out, __component, "2");

  out.n(marko_node0, component);

  out.ee();

  out.be("ul", {
      "class": marko_classValue("dropdown-menu theme-bg" + (input.position ? " dropdown-menu-" + input.position : ""))
    }, "4", component, null, 1);

  if (state.status.length) {
    marko_forOf(state.status, function(status, index) {
      var $keyValue$0 = "@" + ("status-" + index),
          $keyScope$0 = "[" + ($keyValue$0 + "]");

      out.be("li", marko_attrs0, $keyValue$0, component, null, 0, {
          onclick: __component.d("click", "onSelect", false, [
              status
            ])
        });

      Locale_tag({
          text: status.toCapitalCase()
        }, out, __component, "5" + $keyScope$0);

      out.ee();
    });
  } else {
    out.be("div", marko_attrs1, "6", component);

    Locale_tag({
        text: "No Role Found"
      }, out, __component, "7");

    out.ee();
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
